import { Box, styled } from "@mui/material"

const StyledLinks = styled(Box)`
  display: flex;
  font-size: 12px;
  flex-direction: row;
  justify-content: space-between;
  width: 100%;
`
export { StyledLinks }